import DraggableDotsHorizontalIcon from '@/assets/ui/dots/draggable-dots-horizontal.svg';
import DraggableDotsVerticalIcon from '@/assets/ui/dots/draggable-dots-vertical.svg';
import ThreeDotsIcon from '@/assets/ui/dots/three-dots.svg';
import ThreeDotsVerticalIcon from '@/assets/ui/dots/three-dots-vertical.svg';

export {
  DraggableDotsHorizontalIcon,
  DraggableDotsVerticalIcon,
  ThreeDotsIcon,
  ThreeDotsVerticalIcon,
};
